var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.09813 2.65644C8.91459 2.65644 8.74508 2.75494 8.6542 2.91443L4.95928 9.40027C4.46949 10.26 4.26395 11.2525 4.37203 12.2361L4.762 15.7849C4.83139 16.4163 5.32708 16.9164 5.95784 16.9915L8.29569 17.2696C9.839 17.4532 11.4038 17.294 12.8786 16.8035C13.607 16.5613 14.1903 16.0085 14.4714 15.2942L16.3531 10.512C16.3992 10.3951 16.431 10.2731 16.4479 10.1485C16.5905 9.09714 15.6702 8.21017 14.6248 8.39182L10.8527 9.04689C9.66121 9.25384 8.63211 8.20244 8.86468 7.01558L9.59948 3.26555C9.66132 2.94998 9.4197 2.65644 9.09813 2.65644ZM7.21496 2.09448C7.60045 1.41782 8.31934 1.00001 9.09813 1C10.4624 0.999989 11.4873 2.24529 11.225 3.58406L10.4902 7.3341C10.487 7.35016 10.4888 7.35998 10.491 7.36703C10.4936 7.37571 10.4993 7.38588 10.5085 7.39531C10.5177 7.40474 10.5277 7.41055 10.5364 7.41346C10.5433 7.41583 10.5531 7.41772 10.5693 7.41492L14.3413 6.75977C16.4905 6.3865 18.3827 8.20984 18.0893 10.3714C18.0545 10.6274 17.9891 10.8781 17.8946 11.1186L16.0128 15.9008C15.552 17.0718 14.5955 17.9781 13.4013 18.3753C11.6954 18.9427 9.88527 19.1268 8.10003 18.9144L5.76218 18.6364C4.36612 18.4703 3.26904 17.3633 3.11547 15.9659L2.7255 12.417C2.57927 11.0863 2.85736 9.74348 3.52002 8.58022L7.21496 2.09448Z",
    fill: "#F77E0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.577a770925669ee7f38736535278ff70.svg";
export { ForwardRef as ReactComponent };